import { useEffect, useRef, useState } from 'react';

// Returns a ref and a boolean reflecting whether the element is currently in
// view. By default it keeps observing, so the value toggles every time the
// element enters/leaves the viewport (re-triggering reveal animations). Pass
// { once: true } to latch to true after the first entry instead.
const useInView = ({ once = false, threshold = 0.15 } = {}) => {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setInView(true);
                    if (once) observer.unobserve(el);
                } else if (!once) {
                    setInView(false);
                }
            },
            { threshold }
        );

        observer.observe(el);
        return () => observer.disconnect();
    }, [once, threshold]);

    return [ref, inView];
};

export default useInView;
